/** NX Auto Care (nxautocare.online) — Nodex Global LLC contact */
import { COMPANY_NAME, SITE_DOMAIN, SITE_URL } from './site';

export const PHONE = '1-833-597-6924';
export const PHONE_RAW = '+18335976924';

export { COMPANY_NAME };

/** Nodex Global LLC — Sheridan, WY */
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS_FULL = `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`;

export const CONTACT = {
  phone: PHONE,
  phoneTel: PHONE_RAW,
  email: `support@${SITE_DOMAIN}`,
  website: SITE_DOMAIN,
  websiteUrl: SITE_URL,
  company: COMPANY_NAME,
  addressLine1: ADDRESS_LINE1,
  addressLine2: ADDRESS_LINE2,
  address: ADDRESS_FULL,
  hoursWeekdays: 'Mon–Fri: 8AM–8PM EST',
  hoursSaturday: 'Sat: 9AM–5PM EST',
};

export const phoneHref = `tel:${CONTACT.phoneTel}`;
